import React from 'react'
import ProdIOTSumMatRow from './ProdIOTSumMatRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";

const ProdIOTSumMat = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);

    return (
        <UiView>
            <UiViewContent>
                <ul className="uiListTable uiProductionTable uiRawDataView" style={{ minWidth: "1210px" }}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item" /></li>
                            <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Issued" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Returned" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Used" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Wasted" /></li>
                            <li className="uiColumnRight uiColumn70"><SarasTrans value="Unit Cost" /></li>
                            <li className="uiColumnLeft uiColumn100"><SarasTrans value="Remark" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Type" /> </li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            <li>
                                <ProdIOTSumMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} />
                            </li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdIOTSumMat, "prodIOTSumMat", "");
